// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4w-5";
export var imageContainer = "_4w-4";
export var metricsGrid = "_4w-2";
export var productDetailContainer = "_4w-1";
export var productListContainer = "_4w-0";
export var subscriberTableContainer = "_4w-3";